import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { I18NextModule } from 'angular-i18next';
import { IconComponent } from '../../../common/icon/icon.component';
import { OpenDialogService } from '../../../common/open-dialog/open-dialog.service';
import { ScrollableElementsComponent } from '../scrollable-elements/scrollable-elements.component';

@Component({
  selector: 'sharry-golden-carousel',
  standalone: true,
  imports: [I18NextModule, IconComponent, MatButtonModule, ScrollableElementsComponent],
  templateUrl: './golden-carousel.component.html',
  styleUrl: './golden-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoldenCarouselComponent {
  @Input() title: string = 'trip.carousel-pros.title';
  @Input() goldenBoxes: { icon?: string; type?: string; title?: string; subtitle?: string; button?: string }[];

  constructor(private openDialogService: OpenDialogService) {}

  openSupportDialog(): void {
    import('../../dialogs/support-dialog/support-dialog.component').then(({ SupportDialogComponent }) =>
      this.openDialogService.openDialog(SupportDialogComponent, {
        ...{
          autoFocus: false,
          restoreFocus: false,
          width: '90vw',
          maxWidth: '450px',
          minHeight: '200px',
          maxHeight: '84vh',
        },
      }),
    );
  }
}
